import { render, staticRenderFns } from "./FacebookFriends.vue?vue&type=template&id=085d7b89&scoped=true"
import script from "./FacebookFriends.vue?vue&type=script&lang=js"
export * from "./FacebookFriends.vue?vue&type=script&lang=js"
import style0 from "./FacebookFriends.vue?vue&type=style&index=0&id=085d7b89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085d7b89",
  null
  
)

export default component.exports